import { render, staticRenderFns } from "./Pocetna.vue?vue&type=template&id=b8d40722&scoped=true&"
import script from "./Pocetna.vue?vue&type=script&lang=js&"
export * from "./Pocetna.vue?vue&type=script&lang=js&"
import style0 from "./Pocetna.vue?vue&type=style&index=0&id=b8d40722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d40722",
  null
  
)

export default component.exports